module.exports = __webpack_public_path__ + "static/media/image-card-6.bf67d75d.png";